import { Component } from '@angular/core';

@Component({
  selector: 'mprd-joint-offer-skeleton',
  templateUrl: './joint-offer-skeleton.component.html',
  styleUrls: ['./joint-offer-skeleton.component.css'],
})
export class JointOfferSkeletonComponent {
  constructor() {}
}
